// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"30136ea3","540":"aa79f9f9","541":"fcfeed94","611":"60fdfde8"}[chunkId] + ".chunk.js";
};